<template> 
<div>
  <div class="text-white">
    <div class="strike">
        <span>In Programmazione</span>
    </div>
    <div class="d-block">
        <h3 class="pb-2"><br> <span class="text-h2-convergenze"><b>{{tv.numero}}. </b></span> <b>{{tv.sigla}}</b></h3>
        <div class="table-responsive ">
            <table class="table table-borderless table-sm text-white">
                <tr>
                    <td class="text-right"><ficon icon="circle" class="green"></ficon></td>
                    <td class="text-left text-grey"><b>{{currentProgram.title}}</b></td>
                </tr>
                <tr  v-for="(item) in futureProgram" v-bind:key="item.numero">
                    <td class="text-right">{{hourstoDate(item.start)}}</td>
                    <td class="text-left"><b>{{item.title}}</b></td>
                </tr>
            </table>
        </div>
       
    </div>
  </div>
      
</div> 

    
</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'

import utilfunc from '../models/utilfunc.js';

export default {
  name: 'InfoTvMenu',
  data: function() {
    return  {
      
    };
  },
  props: ['currentProgram','futureProgram', 'tv'],
  methods: { 
    hourstoDate(date)
        {
            let hours = utilfunc.datetoHoursStr(date);
            return  hours;
        },   
  },
  computed: {    
  }
}
</script>

<style scoped>

.padr-5 {
    padding-right: 30%;
}
.strike {
        display: block;
        text-align: left;
        overflow: hidden;
        white-space: nowrap; 
    }

    .strike > span {
        position: relative;
        display: inline-block;
    }
	
    .strike > span:before,
    .strike > span:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 9999px;
        height: 2px;
        background: #00ADEE;
    }

    .strike > span:before {
        right: 100%;
        margin-right: 15px;
    }

    .strike > span:after {
        left: 100%;
        margin-left: 15px;
    }
</style>

